var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParkingAppTile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0_4_Icons_MIB3 / 0_4_3_IconMaster / home / parking_app_tile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-38.449929%",
    y1: "-147.847124%",
    x2: "50%",
    y2: "107.053445%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B0F4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F448C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0588CC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0683C8",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.0749668,-9.32256277e-16 L66.9250332,9.32256277e-16 C74.9487019,-5.41667744e-16 77.858278,0.8354305 80.7916113,2.40419433 C83.7249447,3.97295817 86.0270418,6.27505533 87.5958057,9.20838867 C89.1645695,12.141722 90,15.0512981 90,23.0749668 L90,66.9250332 C90,74.9487019 89.1645695,77.858278 87.5958057,80.7916113 C86.0270418,83.7249447 83.7249447,86.0270418 80.7916113,87.5958057 C77.858278,89.1645695 74.9487019,90 66.9250332,90 L23.0749668,90 C15.0512981,90 12.141722,89.1645695 9.20838867,87.5958057 C6.27505533,86.0270418 3.97295817,83.7249447 2.40419433,80.7916113 C0.8354305,77.858278 3.61111829e-16,74.9487019 -6.21504185e-16,66.9250332 L6.21504185e-16,23.0749668 C-3.61111829e-16,15.0512981 0.8354305,12.141722 2.40419433,9.20838867 C3.97295817,6.27505533 6.27505533,3.97295817 9.20838867,2.40419433 C12.141722,0.8354305 15.0512981,5.41667744e-16 23.0749668,-9.32256277e-16 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "0_4_Icons_MIB3-/-0_4_3_IconMaster-/-home-/-parking_app_tile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Parking"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Form---Fill"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.84,
    fill: "url(#linearGradient-2)",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.0749668,1 L66.9250332,1 C74.6655046,1 77.4864411,1.77059696 80.3200125,3.28600753 C83.0764997,4.76019302 85.239807,6.92350032 86.7139925,9.67998753 C88.229403,12.5135589 89,15.3344954 89,23.0749668 L89,23.0749668 L89,66.9250332 C89,74.6655046 88.229403,77.4864411 86.7139925,80.3200125 C85.239807,83.0764997 83.0764997,85.239807 80.3200125,86.7139925 C77.4864411,88.229403 74.6655046,89 66.9250332,89 L66.9250332,89 L23.0749668,89 C15.3344954,89 12.5135589,88.229403 9.67998753,86.7139925 C6.92350032,85.239807 4.76019302,83.0764997 3.28600753,80.3200125 C1.77059696,77.4864411 1,74.6655046 1,66.9250332 L1,66.9250332 L1,23.0749668 C1,15.3344954 1.77059696,12.5135589 3.28600753,9.67998753 C4.76019302,6.92350032 6.92350032,4.76019302 9.67998753,3.28600753 C12.5135589,1.77059696 15.3344954,1 23.0749668,1 L23.0749668,1 Z",
    id: "Form---Border",
    strokeOpacity: 0.11841674,
    stroke: "#00B0F4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5,18 C53.416162,18 55.9157865,18.36825 58,19 C60.0807398,19.6265 61.6435244,20.586 63,22 C64.3495282,23.4175 65.374736,25.1935 66,27.5 C66.6217904,29.8065 67,32.696 67,36 C67,39.6155 66.6495799,42.613 66,45 C65.3486833,47.3835 64.3530019,49.3325 63,50.75 C61.6469981,52.164 59.8550556,53.42425 57.75,54 C55.6414707,54.57925 53.166162,55 50.25,55 C48.305892,55 45.2225586,55 41,55 L41,74 L30,74 L30,18 L50.5,18 Z M41,45 L49,45 C50.4286525,45 51.6494335,44.9617856 52.54,44.75 C53.4339721,44.5346549 53.9636168,44.1673917 54.5,43.5 C55.0363832,42.8326083 55.5439607,41.7013051 55.75,40.5 C55.9526337,39.2986949 56,37.9736998 56,36 C56,34.1864742 55.8842093,32.5064267 55.6577364,31.3620724 C55.4278579,30.2159383 55.0363832,29.3906961 54.5,28.75 C53.9653196,28.1128634 53.1405665,27.7420407 52.25,27.5 C51.3560279,27.259739 50.3792712,27 49,27 L41,27 L41,45 Z",
    id: "P---Fill",
    fill: "url(#linearGradient-4)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5,18.5 C53.3595229,18.5 55.8110528,18.8589685 57.8558452,19.4787686 C59.8457188,20.0779093 61.3416693,20.9935997 62.6378709,22.3447644 C63.9346866,23.7068969 64.9167433,25.4150291 65.5172347,27.6301447 C66.1295047,29.9013296 66.5,32.7467834 66.5,36 C66.5,39.5624435 66.1576491,42.5165299 65.5176835,44.8682019 C64.891212,47.1607803 63.9405725,49.0404332 62.6387404,50.4043246 C61.3445218,51.7568911 59.6325512,52.9667424 57.6175484,53.5178625 C55.6843423,54.0489481 53.437255,54.4442248 50.8171761,54.494568 L50.25,54.5 L40.5,54.5 L40.5,73.5 L30.5,73.5 L30.5,18.5 L50.5,18.5 Z M49,26.5 L40.5,26.5 L40.5,45.5 L49,45.5 L49.3643961,45.4989908 C50.6835097,45.4913162 51.8126499,45.4369151 52.655679,45.2364343 C53.6750991,44.9908728 54.2787931,44.5733807 54.8897299,43.8132262 C55.4672268,43.094679 56.0207358,41.8792844 56.2428042,40.5845223 C56.4494137,39.3596578 56.5,38.0103475 56.5,36 C56.5,34.1483388 56.3794363,32.4333079 56.1482234,31.2650028 C55.8980617,30.0177322 55.4657934,29.1247109 54.8833828,28.4290364 C54.2872838,27.7187116 53.3773964,27.2882696 52.3811345,27.0175026 C51.4501047,26.76728 50.4340358,26.5 49,26.5 L49,26.5 Z",
    id: "P---Border",
    stroke: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingAppTile);
export default __webpack_public_path__ + "static/media/parking_app_tile.d320d1d7fff53983b2ea5def6e6de233.svg";
export { ForwardRef as ReactComponent };